import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { Observable, BehaviorSubject } from 'rxjs';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';

@Component({
  selector: 'app-email-select',
  templateUrl: './email-select.component.html',
  styleUrls: ['./email-select.component.scss'],
  providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: EmailSelectComponent,
      multi: true
    }]
})
export class EmailSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, 
    private staticDictionaryService: StaticDictionaryService,
    private customDialogService: CustomDialogService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  @ViewChild("cityDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  valuesList$: Observable<string[]>;
  term$ = new BehaviorSubject<string>('');

 
  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {

     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
    this.valuesList$ = this.term$.pipe(
      AutoComplete.autocomplete(200, (term => this.staticDictionaryService.getEmails(term))));
    this.filterChange(this.control.value);
  }

  onChange(value: any) {

    this.valueChangeEvent.emit(value);
  }


  public filterChange(filter: any): void {
      this.term$.next(filter);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.filterChange(this.control.value)
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}



